export const recaps = (state) => state.recaps
export const selectAllField = (state) => state.selectAllField
export const selectedRecaps = (state) => state.selectedRecaps
export const totalRecaps = (state) => state.totalRecaps
export const getRecap = (state) => (id) => {
  let invId = parseInt(id)
  return state.recaps.find((recap) => recap.id === invId)
}
